import { render, staticRenderFns } from "./complete_withdraw.vue?vue&type=template&id=5b3b2382&"
import script from "./complete_withdraw.vue?vue&type=script&lang=js&"
export * from "./complete_withdraw.vue?vue&type=script&lang=js&"
import style0 from "./complete_withdraw.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports